import React from "react";
import { useMessageSource } from "react-message-source";
import Typography from "../../ui/widgets/typography";

export default function NoInformationNeeded(): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <Typography variant="body2" component="div">
      {getMessage("RegulatoryInformation.noInformationNeeded")}
    </Typography>
  );
}
